<template>
  <div class="step-menu-layout">
    <FilterShrink class="aside-shrink-container" @change="handelShrinkChange">
      <div class="layout-aside">
        <StepMenu
          :activeIndex="activeMenuIndex"
          :stepMenuList="stepMenuList"
          :showActiveStyle="showActiveMenuStyle"
          @change="handleActiveMenuChange"
        />
        <StandaloneStepMenu
          v-if="standaloneStepMenuList !== null && standaloneStepMenuList !== undefined"
          :activeIndex="activeStandaloneMenuIndex"
          :standaloneStepMenuList="standaloneStepMenuList"
          @change="handleActiveStandaloneMenuChange"
        />
      </div>
    </FilterShrink>
    <div class="layout-main">
      <rect-loading v-if="loading"></rect-loading>
      <div v-if="!hiddenTitle" class="layout-title">{{ layoutTitle }}</div>
      <div class="layout-content">
        <slot>
          <router-view></router-view>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import RectLoading from '@/components/loading/rectLoading.vue'
import FilterShrink from '@/components/common/shrink/filterShrink.vue'
import StepMenu from './stepMenu.vue'
import StandaloneStepMenu from './standaloneStepMenu.vue'

export default {
  components: {
    RectLoading,
    FilterShrink,
    StepMenu,
    StandaloneStepMenu
  },
  props: {
    activeMenuIndex: {
      type: Number,
      required: true
    },
    stepMenuList: {
      type: Array,
      required: true
    },
    activeStandaloneMenuIndex: {
      type: Number,
      required: false
    },
    standaloneStepMenuList: {
      type: Array,
      required: false
    },
    hiddenTitle: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  computed: {
    layoutTitle () {
      const step = this.stepMenuList[this.activeMenuIndex]
      if (step && step.hasOwnProperty('title')) {
        return step.title
      } else if (step && step.hasOwnProperty('titleI18nKey')) {
        return this.$t(step.titleI18nKey)
      } else {
        return ''
      }
    },
    showActiveMenuStyle () {
      return [null, undefined].includes(this.activeStandaloneMenuIndex) ? true : this.activeStandaloneMenuIndex < 0
    }
  },
  created () {

  },
  mounted () {

  },
  methods: {
    handleActiveMenuChange (activeIndex) {
      this.$emit('step-change', activeIndex)
    },
    handleActiveStandaloneMenuChange (activeIndex) {
      this.$emit('standalone-step-change', activeIndex)
    },
    handelShrinkChange () {
      this.$emit('shrink-change')
    }
  }
}
</script>

<style lang="scss" scoped>
.step-menu-layout {
  display: flex;
  margin: 0 auto;
  border-radius: 10px;
  background-color: #f7f7f7;
  box-sizing: border-box;
  position: relative;

  .aside-shrink-container {
    min-height: 80vh;
    &.shrink {
      height: unset;
    }

    ::v-deep {
      .content {
        background: #FFFFFF;
      }
    }
  }

  .layout-aside {
    width: 300px;
    // flex-shrink: 0;
    padding: 60px 15px 50px;
    // border-radius: 10px;
    // background-color: #6c6c6c;
  }

  .layout-main {
    flex: 1;
    display: flex;
    width: 63vw;
    min-width: 980px;
    max-width: 1035px;
    padding: 30px 24px;
    flex-direction: column;

    .layout-title {
      margin-bottom: 15px;
      padding-bottom: 15px;
      border-bottom: 1px solid #cccccc;
      font-size: 18px;
    }

    .layout-content {
      flex: 1;
    }
  }
}
</style>
